var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c(
        "div",
        { class: _vm.$style.header, attrs: { slot: "header" }, slot: "header" },
        [
          _c(
            "i",
            { staticClass: "material-icons", class: _vm.$style.warning },
            [_vm._v(" error_outline ")]
          ),
          _c("div", { class: _vm.$style.texts }, [
            _c("div", [_vm._v(_vm._s(_vm.title))]),
            _vm.showMainButton
              ? _c("div", { class: _vm.$style.subHeader }, [
                  _vm._v(" Are You Sure? "),
                ])
              : _vm._e(),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody hotel-directory",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c("div", { class: _vm.$style.message }, [
            _vm._v(" " + _vm._s(_vm.subTitle) + " "),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.showCancel
            ? _c(
                "button",
                {
                  staticClass: "rbButton",
                  attrs: { type: "button" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              )
            : _vm._e(),
          _vm.showMainButton
            ? _c(
                "button",
                {
                  staticClass: "rbButton mainButton",
                  class: _vm.$style.mainButton,
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("check")]),
                  _vm._v(" " + _vm._s(_vm.mainButtonText) + " "),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }